import { empty, strcasecmp } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { slot, values, isArray, type Arr } from './access';
export interface ShapeshiftDeps {
    layer_value(row: Arr, name: string): unknown;
    layer_entries(row: Arr, name: string): Arr;
    layer_list_entry_uuid(entry: unknown): string;
    passive_ability_entry_is_active(entry: unknown): boolean;
    check_uuid(value: unknown): boolean;
    query_full_item_arr(id: string): Arr | null;
}
/** PHP: janus_shapeshift_form_allowed (includes/functions/janus/core/apply_shapeshift_post_effect.php:21) */
export function janusShapeshiftFormAllowed(ability: Arr, formId: string, env: PortEnv<ShapeshiftDeps>): boolean {
    for (const name of ['shapeshift', 'user_choice_1_shapeshift', 'user_choice_2_shapeshift', 'user_choice_3_shapeshift', 'user_choice_4_shapeshift']) {
        for (const entry of values(env.deps.layer_entries(ability, name))) {
            const id = env.deps.layer_list_entry_uuid(entry);
            if (id !== '' && strcasecmp(id, formId) === 0) return true;
        }
    }
    return false;
}
/** PHP: janus_target_immune_to_shapeshift (includes/functions/janus/core/apply_shapeshift_post_effect.php:49) */
export function janusTargetImmuneToShapeshift(target: Arr, env: PortEnv<ShapeshiftDeps>): boolean {
    if (!empty(env.deps.layer_value(target, 'immune_shapeshift'))) return true;
    for (const container of ['passive_ability', 'feat']) {
        for (const entry of values(env.deps.layer_entries(target, container))) {
            if (!env.deps.passive_ability_entry_is_active(entry)) continue;
            let ability: unknown;
            if (isArray(entry) && !empty(slot(entry, 'item_layer_types'))) ability = entry;
            else {
                const id = env.deps.layer_list_entry_uuid(entry);
                if (id === '' || !env.deps.check_uuid(id)) continue;
                ability = env.deps.query_full_item_arr(id);
            }
            if (isArray(ability) && !empty(env.deps.layer_value(ability, 'immune_shapeshift'))) return true;
        }
    }
    return false;
}
